import React from 'react'
import { generatePath, useHistory } from 'react-router-dom'
import { Button, ChevronRightIcon, OverflowTooltip } from '@diversioteam/diversio-ds'

import { generateCompanyURI } from 'sagas/helpers/generateCompanyURI'
import { AppRoute } from 'routing/AppRoute.enum'
import { usePulseSurveys } from 'hooks/usePulseSurveys'
import { useDuplicatePulseSurveyFromTemplate } from 'hooks/pulseSurveys/useDuplicatePulseSurveyFromTemplate'

import { TemplateListItemProps } from './templateListItem.types'
import * as S from './../panel.styles'

export const TemplateListItem = ({ uuid, title, ...props }: TemplateListItemProps) => {
    const history = useHistory()

    const { onChangeActivePulseSurvey } = usePulseSurveys()

    const { mutate } = useDuplicatePulseSurveyFromTemplate()

    const handleClickTemplate = () => {
        mutate(
            {
                template: uuid,
            },
            {
                onSuccess: (pulseSurvey) => {
                    onChangeActivePulseSurvey(pulseSurvey)

                    history.push(generateCompanyURI(generatePath(AppRoute.PulseSurveyCreate, { id: pulseSurvey.uuid })))
                },
            },
        )
    }

    return (
        <OverflowTooltip overflowDirection="width">
            <S.ListItemWrapper
                onClick={() => {
                    handleClickTemplate()
                }}
                {...props}
            >
                <S.ListItemLabel>{title}</S.ListItemLabel>

                <Button color="transparent" iconOnly aria-hidden={true} aria-label="">
                    <ChevronRightIcon type="line" />
                </Button>
            </S.ListItemWrapper>
        </OverflowTooltip>
    )
}
